import React from 'react'
import { OverflowMenu, OverflowMenuItem } from '../OverflowMenu'
import { updateUserFilteredColumns } from './storeUtils'

const ColumnsFilterButtonTable = ({
  canSaveFilter = true,
  gridApi,
  identifier, // identifier='wtName'|| pageName
  type, // type='table' || ('pivot' || tableOutput)
  userId,
  t,
  linksByUri,
  className = 'overflowFilter bx--btn bx--btn--primary',
  openModal
}) => {
  const onSaveFilteredColumns = (nameFilter, model) => {
    updateUserFilteredColumns({
      identifier,
      type,
      model,
      userId,
      nameFilter
    })
  }

  const btnItems = [
    {
      title: 'FilterMenu.SAVE',
      action: () =>
        openModal('saveMyFilters', {
          ...{
            tableApi: gridApi,
            onSave: onSaveFilteredColumns,
            type,
            identifier,
            t,
            linksByUri,
            userId
          }
        }),
      visible: canSaveFilter
    },
    {
      title: 'FilterMenu.MY_FILTERS',
      action: () =>
        openModal('myFiltersInfo', {
          ...{
            tableApi: gridApi,
            identifier,
            userId,
            type,
            t,
            linksByUri
          }
        }),
      visible: true
    }
  ]

  return (
    <>
      <OverflowMenu
        renderIcon={() => <div>{t('FilterMenu.TITLE')}</div>}
        // key={`${title}-${i}`}
        /*  menuOffset={{
          left: -1
        }} */
        className={className}
      >
        {btnItems.map(
          ({ title, action, visible }, idx) =>
            visible && (
              <OverflowMenuItem
                key={`${title}-${idx}`}
                onClick={action}
                itemText={t(title)}
              />
            )
        )}
      </OverflowMenu>
    </>
  )
}

export default ColumnsFilterButtonTable
